import { render, staticRenderFns } from "./UrlSelector.vue?vue&type=template&id=66d1c3aa&"
import script from "./UrlSelector.vue?vue&type=script&lang=js&"
export * from "./UrlSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports